<span revTooltip [tooltipContent]="getTooltipText()">
	<i [class]="'fa app-status-icon fa-shield ' + getColorClass()"></i>
</span>
